import { render, staticRenderFns } from "./QuantityDetail.vue?vue&type=template&id=24996b83&scoped=true&"
import script from "./QuantityDetail.vue?vue&type=script&lang=js&"
export * from "./QuantityDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuantityDetail.vue?vue&type=style&index=0&id=24996b83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24996b83",
  null
  
)

export default component.exports